import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { Icon } from './icon'
import { colors } from 'utils/colors'
import { Spacer } from './spacer/Spacer'

const SListText = styled(Text)<{ singleLine?: boolean }>`
  display: flex;

  & strong {
    color: var(--c-gray100);
  }
  ${({ singleLine }) =>
    singleLine &&
    css`
      width: 100%;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`

export const ListItem = ({ text, singleLine }: { text: string; singleLine?: boolean }) => {
  return (
    <li>
      <SListText singleLine={singleLine}>{text}</SListText>
    </li>
  )
}

export const ListItemWarning = ({ text }: { text: string }) => {
  return (
    <li>
      <SListText
        css={css`
          display: flex;
          align-items: center;
        `}
      >
        <Icon name="Cancel" color={colors.red[500]} size="1rem" />
        <Spacer size={0.75} axis="horizontal" />
        {text}
      </SListText>
    </li>
  )
}

export const ListItemCancel = ({ text }: { text: string }) => {
  return (
    <li>
      <SListText
        css={css`
          display: flex;
          align-items: center;

          svg {
            min-width: 1rem;
          }
        `}
      >
        <Icon name="Warning" color={colors.red[500]} size="1rem" />
        <Spacer size={0.75} axis="horizontal" />
        {text}
      </SListText>
    </li>
  )
}
